import { useEffect, useState } from "react";

/**
 * Re-renders the caller every `intervalMs` while `enabled` is true. Re-syncs on tab
 * focus / visibility change because background tabs throttle setInterval to ~1/min.
 * Returns `Date.now()` at each tick.
 */
export const useTick = (intervalMs: number, enabled: boolean): number => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!enabled) return;
        const id = setInterval(() => setNow(Date.now()), intervalMs);
        const resync = () => setNow(Date.now());
        window.addEventListener("focus", resync);
        document.addEventListener("visibilitychange", resync);
        return () => {
            clearInterval(id);
            window.removeEventListener("focus", resync);
            document.removeEventListener("visibilitychange", resync);
        };
    }, [intervalMs, enabled]);

    return now;
};
